import { render } from "./LastNMsgsOfUnitTable.vue?vue&type=template&id=1f5fbed0&scoped=true"
import script from "./LastNMsgsOfUnitTable.vue?vue&type=script&lang=js"
export * from "./LastNMsgsOfUnitTable.vue?vue&type=script&lang=js"

import "./LastNMsgsOfUnitTable.vue?vue&type=style&index=0&id=1f5fbed0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5fbed0"]])

export default __exports__